import Youtube from './directives/Youtube';

export default angular.module('edge.platform.widgets.youtube', []).directive('gwYoutube', Youtube);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/youtube/module.js
// module id = 1189
// module chunks = 0